import { render, staticRenderFns } from "./render-panorama-grouped-status-column-value.vue?vue&type=template&id=68b12373"
import script from "./render-panorama-grouped-status-column-value.vue?vue&type=script&lang=js"
export * from "./render-panorama-grouped-status-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b12373')) {
      api.createRecord('68b12373', component.options)
    } else {
      api.reload('68b12373', component.options)
    }
    module.hot.accept("./render-panorama-grouped-status-column-value.vue?vue&type=template&id=68b12373", function () {
      api.rerender('68b12373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/new-panorama/components/render-panorama-grouped-status-column-value.vue"
export default component.exports